import { toCSSPixel } from '../../../utils/styles'

export function getIconStyle({ color, size, style, svgMeta, svgSize }) {
  return {
    ...style,
    '--icon-color-base': color,
    '--icon-container-size-base': toCSSPixel(size),
    '--icon-width-base':
      toCSSPixel(svgSize) || toCSSPixel(svgMeta?.width) || toCSSPixel(size),
  }
}
